export * from './routes';
export * from './backendAPI';

/** App version — read from package.json at build time */
export const APP_VERSION = __APP_VERSION__;

/** API URLs per environment — injected via Vite env vars */
export const API_URL = import.meta.env.VITE_API_URL as string;

/** Environment */
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

/** Public store listings — used by the invite message (#1) and the force-update gate (#4) */
export const STORE_URL_IOS = 'https://apps.apple.com/app/id6746802371';
export const STORE_URL_ANDROID = 'https://play.google.com/store/apps/details?id=racore.app';
